export enum FileType {
    None = 'None',
    Image = 'Image',
    Document = 'Document',
}

export type OnBlur = (fieldName: string, value: string, isDirty: boolean) => void;
